import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCalendarPenRegularReportIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 32 32",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M21.3 3q1.2.1 1.3 1.3v2.2h1.8c2 0 3.6 1.6 3.6 3.5v7.5l-1-.1h-.7l-1 .1V10q0-.8-.9-.9H6.6q-.9 0-1 .9v15.8q.1.7 1 .8h7.6v.6q0 1.2.7 2H6.6c-2 0-3.6-1.5-3.6-3.4V10c0-2 1.6-3.5 3.6-3.5h1.8V4.3Q8.5 3.1 9.7 3q1.2.1 1.3 1.3v2.2h9V4.3q0-1.2 1.3-1.3M18 22.4q1.1.1 1.2 1.1v3.8q0 1-1.2 1h-.7a1 1 0 0 1-1.1-1v-3.8q.1-1 1-1.1zm4.5-4.5q1.1.1 1.2 1.1v8.3q0 1-1.2 1h-.7a1 1 0 0 1-1.1-1V19q.1-1 1-1.1zm4.7 1.5h.3v.1h.2v.1q.5.3.5.9v6.8q0 1-1.2 1h-.7a1 1 0 0 1-1.1-1v-6.8l.1-.6.3-.3h.1l.4-.2zm-8.5-1.8L14.2 22q-.4.6-1.2.7l-2.2.4a.5.5 0 0 1-.6-.6l.4-2.2q.1-.8.7-1.2l4.4-4.5zm-1.1-4.9a2.1 2.1 0 0 1 3 3l-1.1 1-3-2.9z" })
});
export default SvgCalendarPenRegularReportIcon;
